// extracted by mini-css-extract-plugin
export var acitonButtons = "_i8-0";
export var additionalIcon = "_i8-f";
export var block = "_i8-1";
export var blockContent = "_i8-7";
export var blockDescription = "_i8-8";
export var blockIcon = "_i8-9";
export var blockTitle = "_i8-6";
export var border = "_i8-a";
export var center = "_i8-l";
export var edge = "_i8-b";
export var edgeLabel = "_i8-c";
export var edgePath = "_i8-d";
export var error = "_i8-e";
export var flowchart = "_i8-g";
export var flowchartContent = "_i8-h";
export var highlighted = "_i8-3";
export var hover = "_i8-4";
export var icon = "_i8-i";
export var left = "_i8-m";
export var navButton = "_i8-j";
export var navButtons = "_i8-k";
export var right = "_i8-n";
export var selected = "_i8-2";
export var small = "_i8-5";